// src/auth/RequireTeacher.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

export default function RequireTeacher() {
  const { user, isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!user?.isTeacher)  return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
